<svg
  id="svgElement">
  <use 
    attr.href="assets/icons/library-new.svg?v=143#{{ icon }}">
  </use>
</svg>
<div class="icon__label">{{ count }}</div>
